import React from 'react';
import { IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { DqText } from '../dq-text';
import './ControllerCard.scss';
import { ControllerMessages } from 'src/intl/ControllerMessages';
import { useIntl } from 'react-intl';
import { chevronForward } from 'ionicons/icons';
import classNames from 'classnames';
import { GenericMessages } from 'src/intl/GenericMessages';

export interface ControllerCardProps {
  /**
   * The physical serial number of the controller, if provided.
   */
  physicalSerialNumber?: string;
  /**
   * The router link of the controller card.
   */
  routerLink?: string;

  /**
   * The display name of the firmware.
   */
  firmwareDisplayName?: string;
  /**
   * Whether or not the card is active/connected
   */
  active?: boolean;
  /** Whether or not the card is interactable. */
  disabled?: boolean;
  /**
   * The callback triggered when the card is clicked.
   */
  onClick?: () => void;
}

export const ControllerCard: React.FC<ControllerCardProps> = ({
  routerLink,
  physicalSerialNumber,
  onClick,
  firmwareDisplayName,
  disabled,
  active,
}) => {
  const intl = useIntl();

  const formattedControllerLabel = intl.formatMessage(ControllerMessages.controllerIdLabel, {
    physicalId: physicalSerialNumber ? physicalSerialNumber : intl.formatMessage(GenericMessages.unknownPlaceholder),
  });

  return (
    <IonCard
      onClick={onClick}
      routerLink={routerLink}
      disabled={disabled}
      className={classNames('controller-card', active && 'connected-controller')}
    >
      <IonCardContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <DqText variant="body-strong">{formattedControllerLabel}</DqText>
            </IonCol>
            <IonCol size="auto">
              <IonIcon color="primary" icon={chevronForward} />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="auto" sizeLg="1">
              <DqText color="dark" variant="body-small">
                {intl.formatMessage(ControllerMessages.firmware)}
              </DqText>
            </IonCol>
            <IonCol className="controller-card-data-column">
              <DqText variant="body-small">{firmwareDisplayName}</DqText>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};
